export default "__VITE_ASSET__CtY6IPpn__"